"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComponentsLibraries = exports.getComponentsLibrariesFromURL = exports.whitelist = void 0;
var getComponentsLibrariesFromURL_1 = require("./getComponentsLibrariesFromURL");
Object.defineProperty(exports, "getComponentsLibrariesFromURL", { enumerable: true, get: function () { return getComponentsLibrariesFromURL_1.getComponentsLibrariesFromURL; } });
var DESIGN_SYSTEMS_NAMESPACE = 'dsgnsys';
function getArtifactID(_a) {
    var artifactId = _a.artifactId, namespace = _a.namespace;
    /**
     * There are two libs are published with the same artifact id, which affects on runtime:
     * https://github.com/wix-private/editor-elements/blob/remove-tb-from-ee/packages/editor-elements-registry/src/toolbox/registryAPI.ts#L153
     *
     * This function allows to override the artifact ID
     */
    if (namespace === DESIGN_SYSTEMS_NAMESPACE) {
        return artifactId + "-design-systems";
    }
    return artifactId;
}
/**
 * This is a temp source of truth until a better alternative is supplied via DevCenter or something similar
 */
exports.whitelist = [
    {
        artifactId: 'editor-elements',
        namespace: 'wixui',
    },
    {
        artifactId: 'editor-elements',
        namespace: 'dsgnsys',
    },
];
/**
 * Will return list of components libraries with actual urls to each one of them.
 * In case when "serviceTopology" is not provided a whitelist of libraries
 * without urls will be returned
 */
exports.getComponentsLibraries = function (serviceTopology, url, prefix) {
    var urlLibraries = [];
    if (url) {
        urlLibraries.push.apply(urlLibraries, getComponentsLibrariesFromURL_1.getComponentsLibrariesFromURL(url, prefix));
    }
    if (!serviceTopology) {
        return __spreadArrays(urlLibraries);
    }
    var topologyLibraries = exports.whitelist.reduce(function (acc, lib) {
        var artifactId = lib.artifactId;
        var libraryEntryInTopology = serviceTopology[artifactId] ||
            serviceTopology.scriptsLocationMap[artifactId];
        if (typeof libraryEntryInTopology === 'string') {
            acc.push(__assign(__assign({}, lib), { artifactId: getArtifactID({ artifactId: artifactId, namespace: lib.namespace }), url: libraryEntryInTopology }));
        }
        return acc;
    }, []);
    return __spreadArrays(topologyLibraries, urlLibraries);
};
//# sourceMappingURL=getComponentsLibraries.js.map